import React from 'react';
import { paymentLogoUrl, paymentLogoSizeClass } from '@/constants/paymentLogos';

/**
 * Visa + Mastercard (tek PNG), isteğe bağlı Revolut.
 */
export default function PaymentBrandLogos({
  className = '',
  showRevolut = false,
  bankLabel = null,
  size = 'default',
}) {
  const sz = paymentLogoSizeClass[size] || paymentLogoSizeClass.default;

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <div
        className={`inline-flex items-center rounded-lg border border-slate-200/90 bg-white shadow-sm ${sz.wrap}`}
        aria-hidden
      >
        <img
          src={paymentLogoUrl.visaMastercard}
          alt="Visa, Mastercard"
          className={`${sz.img} shrink-0 object-contain object-left`}
          loading="lazy"
          decoding="async"
          draggable={false}
        />
      </div>
      {showRevolut && (
        <img
          src={paymentLogoUrl.revolut}
          alt="Revolut"
          className={`${sz.extra} w-auto shrink-0 object-contain`}
          loading="lazy"
          decoding="async"
          draggable={false}
        />
      )}
      {bankLabel && (
        <span className={`${sz.label} text-muted-foreground ml-auto shrink-0 max-w-[14rem] sm:max-w-none text-right sm:text-left`}>
          {bankLabel}
        </span>
      )}
    </div>
  );
}
